import request from '../../../lib/request';
import { RPC } from '../../../constants';

const sendAppNotification = (message) =>
  request({
    url: RPC.GEESTIONE_AVVISO,
    method: 'POST',
    data: {
      method: 'send_app_notification',
      params: { message },
    },
  });

const GestioneAvvisoService = {
  sendAppNotification,
};

export default GestioneAvvisoService;



// WEBPACK FOOTER //
// ./app/shared/services/rpc/gestione-avviso/index.js